import type { OptionsDocument, Pipeline } from 'paintscout'

export function updatePipeline(args: { pipeline: Pipeline; options: OptionsDocument }): OptionsDocument {
  const { options, pipeline } = args
  const { pipelines } = options.options

  const order = pipelines ? [...pipelines.order] : [pipeline.key]
  const orderIndex = order.indexOf(pipeline.key)
  if (orderIndex === -1) {
    order.push(pipeline.key)
  }

  return {
    ...options,
    options: {
      ...options.options,
      pipelines: {
        ...pipelines,
        values: pipelines
          ? {
              ...pipelines.values,
              [pipeline.key]: {
                ...pipelines.values[pipeline.key],
                ...pipeline
              }
            }
          : {
              [pipeline.key]: {
                ...pipeline
              }
            },
        order
      }
    }
  }
}
